"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const archive_1 = require("../../../app/dist/archive");
exports.toolDef = {
    name: 'loom_archive',
    description: 'Archive a Loom doc (by id) or an entire thread/weave folder (by { weaveId, threadId? }) by moving it under the single top-level loom/.archive/ tree, mirroring its weave/thread path (e.g. loom/core-engine/foo/plans/x.md → loom/.archive/core-engine/foo/plans/x.md). Recoverable via loom_restore. Pass exactly one of: id, or weaveId (+ optional threadId). Use this tool — do not move files directly.',
    inputSchema: {
        type: 'object',
        properties: {
            id: { type: 'string', description: 'Document id to archive (mutually exclusive with weaveId)' },
            weaveId: { type: 'string', description: 'Weave to archive (whole folder), or the weave of the thread to archive' },
            threadId: { type: 'string', description: 'Thread to archive (requires weaveId)' },
        },
        required: [],
    },
};
async function handle(root, args) {
    const id = args['id'];
    const weaveId = args['weaveId'];
    const threadId = args['threadId'];
    const input = id
        ? { id }
        : { weaveId: weaveId, threadId };
    const result = await (0, archive_1.archiveItem)(input, {
        getActiveLoomRoot: () => root,
        resolveDocIdOrThrow: dist_1.resolveDocIdOrThrow,
        fs,
    });
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
